import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AuthUserModel} from '../../models/user.model';
import {environment} from '../../../../../environments/environment';
import {TokenModel} from '../../models/token.model';
import {AuthService} from "../auth.service";

const API_USERS_URL = `${environment.apiUrl}/api/users`;
const API_LOGIN_URL = `${environment.apiUrl}/authentication_token`;
const API_REFRESH_TOKEN_URL = `${environment.apiUrl}/api/refresh_token`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {}

  login(email: string, password: string): Observable<TokenModel> {
    return this.http.post<TokenModel>(API_LOGIN_URL, {
      email,
      password,
    });
  }

  refreshToken(token: string): Observable<TokenModel> {
    return this.http.post<TokenModel>(API_REFRESH_TOKEN_URL, {
      refresh_token: token
    });
  }

  registerUser(user: AuthUserModel): Observable<AuthUserModel> {
    return this.http.post<AuthUserModel>(API_USERS_URL, user);
  }

  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/reset-password-code`, {email});}
  getUserByTokenStorage(): Observable<AuthUserModel> {
    return this.http.get<AuthUserModel>(`${API_USERS_URL}/`+localStorage.getItem(AuthService.LS_AUTH_USER_ID_KEY));
  }

  changePasswordWithCode(parameters: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/check-password-code`, parameters);
  }

  changePassword(parameters: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/bk/change_password`, parameters);
  }
}
